import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { ICrmSurveyFormActionTypes } from "../../action-types/crm-survey/ICrmSurveyFormActionTypes";
import { ICrmSurveyFormReducer } from "../../page-state-model/crm-survey/ICrmSurveyFormReducer";
const iniState: ICrmSurveyFormReducer = {
    status: ePageBaseStatus.is_not_initialization,
    crmSurveyForms: []
}
export const crmSurveyFormReducer = (state: ICrmSurveyFormReducer = iniState, action: ICrmSurveyFormActionTypes): ICrmSurveyFormReducer => {
    switch (action.type) {
        case "CRM_SURVEY_FORM_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "CRM_SURVEY_FORM_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                crmSurveyForms: action.payload
            }
        case "CRM_SURVEY_FORM_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                crmSurveyForms: []
            }
        case "CRM_SURVEY_FORM_SELECT_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "CRM_SURVEY_FORM_SELECT_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                crmSurveyForms: action.payload
            }
        case "CRM_SURVEY_FORM_SELECT_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                crmSurveyForms: []
            }
        case "CRM_SURVEY_FORM_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "CRM_SURVEY_FORM_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "CRM_SURVEY_FORM_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "CRM_SURVEY_FORM_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "CRM_SURVEY_FORM_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "CRM_SURVEY_FORM_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "CRM_SURVEY_FORM_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "CRM_SURVEY_FORM_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
       
        default:
            return state;
    }
}